import React from "react";
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native'
import styles from "../../styles";
import Header, { HeaderRight } from "../../components/Header";
import { AppStore, PlayStore } from "../../assets";
import { PrimaryTitle } from "../../components/labels";
import Button from "../../components/form/Button";
import localize from "../../localize";


export default function OpenNativeapp({ history }) {

    const _iosApp = () => {
        // if (global.APP_PLATFORM() === "ios")
        //     return window.location.href = "wc3.woogiu.com://"
        _browserApp("https://apps.apple.com/us/app/daily-vitals-powered-by-woogi/id1463546063")
    }

    const _androidApp = () => {
        let storeOpen = "intent://wc3.woogiu.com#Intent;scheme=http;package=com.woogiworld.dailyvitals;end";
        let storeLink = "https://play.google.com/store/apps/details?id=com.woogiworld.dailyvitals"
        window.location.replace(storeOpen);
        setTimeout(() => _browserApp(storeLink), 700);
    }

    const _browserApp = (url) => {
        return window.open(
            url || "https://wc3.woogiu.com",
            "_blank"
        );
    }

    return (
        <View style={styles.container}>
            <Header
                title="Download App"
                right={(<HeaderRight onPress={() => history.push("/dashboard")} />)}
            />
            <View style={pageStyles.container}>
                <PrimaryTitle>
                    {localize.Daily_Vitals_is_also_available_as_an_App}
                </PrimaryTitle>
                <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => _iosApp()}
                    style={{ marginTop: 40 }}
                >
                    <Image
                        source={AppStore}
                        style={pageStyles.imgBtn}
                        resizeMode="contain"
                    />
                </TouchableOpacity>

                <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => _androidApp()}
                    style={{ marginTop: 10, marginBottom: 10 }}
                >
                    <Image
                        source={PlayStore}
                        style={pageStyles.imgBtn}
                        resizeMode="contain"
                    />
                </TouchableOpacity>
                <Button
                    title={localize.Continue_in_web_app}
                    size="small"
                    variant="outline"
                    onPress={() => history.push({ pathname: "/dashboard" })}
                />
            </View>
        </View>
    );
}

const pageStyles = StyleSheet.create({
    container: {
        padding: 15,
        flex: 1,
        paddingHorizontal: 45
    },
    imgBtn: {
        height: 40,
        flex: 1
    }
})